import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { DataPerfilModel, PerfilModel }
from '../../models/configuration/perfil.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
UpdatePerfilUseCase
implements UseCase<
DataPerfilModel,
PerfilModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataPerfilModel
    ):
    Observable<PerfilModel> {

        return this.repository
            .updateperfil(
                params
            );
    }
}